"use client";

import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type UserState = {
  token: string | null;
  hydrated: boolean;
  setToken: (token: string) => void;
  clearToken: () => void;
  setHydrated: (hydrated: boolean) => void;
};

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      token: null,
      hydrated: false,
      setToken: (token) => {
        const value = token.trim();
        if (!value) return;
        set({ token: value });
      },
      clearToken: () => set({ token: null }),
      setHydrated: (hydrated) => set({ hydrated }),
    }),
    {
      name: "user",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ token: state.token }),
      onRehydrateStorage: () => (state) => {
        state?.setHydrated(true);
      },
    },
  ),
);

export function getUserStoreToken() {
  return useUserStore.getState().token;
}

export function setUserStoreToken(token: string) {
  useUserStore.getState().setToken(token);
}

export function clearUserStoreToken() {
  useUserStore.getState().clearToken();
}

